import { Deserializable } from '../../protocols/deserializable';
import { MenuStyleObject } from '../../enum/dto/menu-style-object.enum';

export class MenuStyle implements Deserializable {
  public configurationId: string;
  public id: string;
  public sectionId: string;
  public objectId: string;
  public objectType: MenuStyleObject;
  public fontSize: number;
  public fontColor: string;
  public backgroundColor: string;
  public bold: boolean;
  public italics: boolean;
  // Form Group
  public fontDecoration: [boolean, boolean] = [false, false]; // [bold, italics]
  public applyToProductVariants: boolean = false;

  static newStyle(): MenuStyle {
    const s = new MenuStyle();
    s.fontSize = 100;
    s.bold = false;
    s.italics = false;
    return s;
  }

  public onDeserialize() {}
}
